<div class="dialog-header" data-testid="reference-files-dialog">
  <h3 mat-dialog-title class="dialog-title">What are reference files?</h3>
  <button
    class="close-x"
    (click)="close()"
    aria-label="Close dialog"
    data-testid="reference-files-close-btn"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
        fill="white"
      />
    </svg>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <p>
    <strong>Reference files</strong> will help the linguist and/or typesetter
    deliver a high quality end document.
  </p>

  <p class="dialog-examples">Examples:</p>

  <ul class="reference-examples">
    <li>
      If you are uploading an editable file that you have a pdf for, you can
      upload the pdf here so the supplier can duplicate the
      <em>'look and feel'</em>.
    </li>
    <li>
      If you are uploading a regulatory document, you can use this field to
      upload any supporting research articles that are relevant to your
      document.
    </li>
  </ul>
</mat-dialog-content>
